import React from 'react';
import ClientsList from '../../components/Clients/ClientsList';

export const Clients = () => {
  return (
    <ClientsList />
  );
}